import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

const NO_SPECIALIST_IMAGE =
  '//www.nerdwallet.com/cdn/press-pages/images/specialists/Placeholder_Specialist.gif';
const TWITTER_URL = 'https://twitter.com/';

const SpecialistsArticle = ({ article }) => {
  const {
    nw_user_image: image,
    link,
    name,
    nw_user_job_title: title,
    nw_user_specialties: specialists,
    nw_user_experience: experience,
    nw_user_education: education,
    nw_user_featured_in: featuredIn,
    nw_twitter: twitter,
    nw_linkedin: linkedin,
  } = article;
  const imageStyle = {};
  const backgroundImageURI = _.get(image, 'url', NO_SPECIALIST_IMAGE);
  imageStyle.backgroundImage = `url(${backgroundImageURI})`;

  const ExpertsImage = link ? (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content -- directive added automatically by Shepherd migration
    <a href={link} className="press-experts__img" style={imageStyle} />
  ) : (
    <div className="press-experts__img" style={imageStyle} />
  );

  const Name = name && <h2 className="press-experts__name">{name}</h2>;

  const Title = title && <div className="press-experts__title">{title}</div>;

  const Specialties = specialists && (
    <div className="press-experts__spec">
      <b>Specialties:</b> {specialists}
    </div>
  );

  const Experience = experience && (
    <div className="press-experts__exp">
      <b>Experience:</b> {experience}
    </div>
  );

  const Education = education && (
    <div className="press-experts__edu">
      <b>Education:</b> {education}
    </div>
  );

  const features =
    featuredIn &&
    _.isArray(featuredIn) &&
    featuredIn
      .map((featuredInItem) => (
        <a href={featuredInItem.url} key={featuredInItem.name}>
          {featuredInItem.name}
        </a>
      ))
      .reduce((prev, curr) => [prev, ', ', curr], []);

  const FeaturedIn = features && (
    <div className="press-experts__feat">
      <b>Featured in: </b>
      {features}
    </div>
  );

  const Twitter = twitter && (
    <li>
      <a href={TWITTER_URL + twitter} className="twitter">
        <svg viewBox="0 0 512 512">
          <path d="M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z" />
        </svg>
      </a>
    </li>
  );

  const Linkedin = linkedin && (
    <li>
      <a href={linkedin} className="linkedin">
        <svg viewBox="0 0 512 512">
          <path d="M186.4 142.4c0 19-15.3 34.5-34.2 34.5 -18.9 0-34.2-15.4-34.2-34.5 0-19 15.3-34.5 34.2-34.5C171.1 107.9 186.4 123.4 186.4 142.4zM181.4 201.3h-57.8V388.1h57.8V201.3zM273.8 201.3h-55.4V388.1h55.4c0 0 0-69.3 0-98 0-26.3 12.1-41.9 35.2-41.9 21.3 0 31.5 15 31.5 41.9 0 26.9 0 98 0 98h57.5c0 0 0-68.2 0-118.3 0-50-28.3-74.2-68-74.2 -39.6 0-56.3 30.9-56.3 30.9v-25.2H273.8z" />
        </svg>
      </a>
    </li>
  );

  return (
    <li>
      <article className={classnames('press-experts__cont', 'specialists')}>
        {ExpertsImage}
        <header className="press-experts__details">
          {Name}
          {Title}
          {Experience}
          {Education}
          {Specialties}
          {FeaturedIn}
        </header>
        <div className="press-experts-social">
          <ul>
            {Twitter}
            {Linkedin}
          </ul>
        </div>
      </article>
    </li>
  );
};

SpecialistsArticle.propTypes = {
  article: PropTypes.shape({
    nw_user_image: PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
    link: PropTypes.string,
    name: PropTypes.string,
    nw_user_job_title: PropTypes.string,
    nw_user_specialties: PropTypes.string,
    nw_user_experience: PropTypes.string,
    nw_user_education: PropTypes.string,
    nw_user_featured_in: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
        })
      ),
      PropTypes.oneOf(['']),
    ]),
    nw_twitter: PropTypes.string,
    nw_linkedin: PropTypes.string,
  }).isRequired,
};

SpecialistsArticle.displayName = 'SpecialistsArticle';

export default SpecialistsArticle;
